/* cheat. parent has class at first rendering and is then removed.
 * this is a 'perspective' workaround so that it doesn't seem as though widgets below this one
 * are loaded first, as all widgets have been and do load asynchronously.
 * this workaround assumes that the parent widget is configured to be the full width of the page */
export function firstLoadCheat(el: HTMLElement): void {
    while (el != null) {
        if (el.classList.contains('cmps-widget-coaching-insight--first-load')) {
            el.classList.remove('cmps-widget-coaching-insight--first-load');
            el = null;
        } else {
            el = el.parentElement;
        }
    }
}
